// import React, { useState, useEffect } from 'react';
import React, { useState } from 'react';

import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { 
  FileText, 
  Calendar, 
  TrendingUp, 
  Users, 
  Briefcase, 
  User, 
  Target,
  Settings,
  DollarSign
} from 'lucide-react';

// Import page components
import DocumentsPage from './pages/DocumentsPage';
import EventManager from './pages/EventManager';
import ChronologyPage from './pages/ChronologyPage';
import PerformanceReviewsPage from './pages/PerformanceReviewsPage';
import ManagerChainPage from './pages/ManagerChainPage';
import ProjectsGrid from './pages/ProjectsGrid';
import RoleProfilePage from './pages/RoleProfilePage';
import GradExpectationsPage from './pages/GradExpectationsPage';
import AiToolsPage from './pages/AiToolsPage';
import CompBenchmarksPage from './pages/CompBenchmarksPage';
import { Layout, Menu, Breadcrumb } from 'antd';
import 'antd/dist/reset.css';

const { Header, Content, Footer, Sider } = Layout;

// const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8787';

function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const navigation = [
    { name: 'Documents', href: '/', icon: FileText, sub: [
      { name: 'Performance Reviews', href: '/performance-reviews', icon: TrendingUp },
      { name: 'Role Profile', href: '/role-profile', icon: User },
      { name: 'GRAD Expectations', href: '/grad-expectations', icon: Target },
      { name: 'Comp Benchmarks', href: '/comp-benchmarks', icon: DollarSign },
    ]},
    { name: 'Event Manager', href: '/event-manager', icon: Settings },
    { name: 'AI Tools', href: '/ai-tools', icon: Settings },
    { name: 'Chronology', href: '/chronology', icon: Calendar },
    { name: 'Manager Chain', href: '/manager-chain', icon: Users },
    { name: 'Projects', href: '/projects', icon: Briefcase },
  ];

  return (
    <Router>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={sidebarOpen} onCollapse={setSidebarOpen}>
          <div className="logo" />
          <Menu theme="dark" defaultSelectedKeys={['/']} mode="inline">
            {navigation.map((item) => (
              item.sub ? (
                <Menu.SubMenu key={item.name} icon={<item.icon />} title={item.name}>
                  {item.sub.map(subItem => (
                    <Menu.Item key={subItem.href} icon={<subItem.icon />}>
                      <Link to={subItem.href}>{subItem.name}</Link>
                    </Menu.Item>
                  ))}
                </Menu.SubMenu>
              ) : (
                <Menu.Item key={item.href} icon={<item.icon />}>
                  <Link to={item.href}>{item.name}</Link>
                </Menu.Item>
              )
            ))}
          </Menu>
        </Sider>
        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: 0 }} />
          <Content style={{ margin: '0 16px' }}>
            <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>User</Breadcrumb.Item>
              <Breadcrumb.Item>Bill</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background" style={{ padding: 24, minHeight: 360 }}>
              <Routes>
                <Route path="/" element={<DocumentsPage />} />
                <Route path="/event-manager" element={<EventManager />} />
                <Route path="/ai-tools" element={<AiToolsPage />} />
                <Route path="/chronology" element={<ChronologyPage />} />
                <Route path="/performance-reviews" element={<PerformanceReviewsPage />} />
                <Route path="/manager-chain" element={<ManagerChainPage />} />
                <Route path="/projects" element={<ProjectsGrid />} />
                <Route path="/role-profile" element={<RoleProfilePage />} />
                <Route path="/grad-expectations" element={<GradExpectationsPage />} />
                <Route path="/comp-benchmarks" element={<CompBenchmarksPage />} />
              </Routes>
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>Ant Design ©2023 Created by Ant UED</Footer>
        </Layout>
      </Layout>
    </Router>
  );
}

// NavLink component for active state
function NavLink({ to, icon: Icon, children }: { to: string; icon: any; children: React.ReactNode }) {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Link
      to={to}
      className={`group flex items-center px-2 py-2 text-sm font-medium rounded-md ${
        isActive
          ? 'bg-blue-100 text-blue-900'
          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
      }`}
    >
      <Icon className="mr-3 h-5 w-5" />
      {children}
    </Link>
  );
}

export default App;
